import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import qs from 'qs';
import {message} from 'lark';
import {logout} from '~/service/login';
import layoutModel from '~/model/layout';
import WebLogoutSuccess from './Web/LogoutSuccess';
import H5LogoutSuccess from './H5/LogoutSuccess';

// login 和logout接口的响应data的to字段的可能取值
const TO = {
    LOGOUT: 'p_logout',
};

class Logout extends Component {
    constructor(props) {
        super(props);
        const {location} = props;
        const {search = ''} = location;
        this.search = search;
        const queryParams = qs.parse(search.substr(1));
        const {service = '', renew = ''} = queryParams;
        this.service = service;
        this.renew = renew;
        this.state = {
            to: null,
            next: null,
        };
    }

    componentDidMount = () => {
        const {layout: {shouldRender}, dispatch} = this.props;
        logout({data: {service: this.service}, search: this.search})
            .then(loginRes => {
                const {data = {}} = loginRes;
                const {to, next} = data;
                if (to === TO.LOGOUT) {
                    if (next) {
                        window.location.href = next;
                    }
                    else {
                        // 是否应该渲染
                        if (!shouldRender) {
                            dispatch(layoutModel.updateShouldRender(true));
                        }
                        this.setState({
                            ...data
                        });
                    }
                }
            })
            .catch(logoutErr => {
                const {msg = ''} = logoutErr;
                if (msg) {
                    message.error(msg);
                }
            });
    };

    render() {
        const {to, next} = this.state;
        const {layout: {shouldRender}, agent: {isMobile}} = this.props;
        // 等注销请求响应后再渲染内容, 响应返回后to不为空
        if (!to || !shouldRender) {
            return null;
        }
        return (
            next
                ? null
                : isMobile ? <H5LogoutSuccess /> : <WebLogoutSuccess />
        );

    }
}

Logout.propTypes = {
    location: PropTypes.shape({
        search: PropTypes.string.isRequired,
    }).isRequired,
    history: PropTypes.shape({
        push: PropTypes.func.isRequired,
    }).isRequired,
    agent: PropTypes.shape({
        isMobile: PropTypes.bool.isRequired
    }).isRequired,
    layout: PropTypes.shape({
        shouldRender: PropTypes.bool.isRequired,
    }).isRequired,
    dispatch: PropTypes.func.isRequired,
};

export default connect(({agent, layout}) => ({agent, layout}))(Logout);
